import store from 'store'

/**
 * Return a correct URL to be user in the Messenger.
 * This function adjusts '/', so you can send the url param as you prefer, this will fix it.
 *
 * @param url
 * @return {string}
 */
export const url = (url = null) => {
  let basePath = store.get('basePath')

  if (!url) return basePath

  if (basePath[basePath.length - 1] === '/') {
    basePath = basePath.substring(0, basePath.length)
  }

  if (url[0] === '/') {
    url = url.substring(1)
  }

  return basePath + '/' + url
}

/**
 * Return if you are in Conversation.
 *
 * @return {boolean}
 */
export const areWeInAConversation = () => {
  // eslint-disable-next-line no-undef
  return location.pathname.indexOf('/conversation/') !== -1
}

/**
 * Return if you are a super user
 * @return {boolean}
 */
export const isSuperUser = () => {
  const isSuperUser = store.get('isSuperUser')
  return isSuperUser
}

/**
 * Return conversationId from the URL.
 * @return {string}
 */
export const getConversationIdFromUrl = () => {
  // eslint-disable-next-line no-undef
  let pathname = location.pathname.split('/')
  return pathname[pathname.length - 1]
}

export const getOtherUserFromConversation = conversation => {
  const currentUser = store.get('user')
  return conversation.members.find(c => c.userId !== currentUser.userId)
}

export const parseUrl = url => {
  let channel = url.split('_')
  return channel[channel.length - 2] + '_' + channel[channel.length - 1]
}

export const uuid4 = () => {
  let d = new Date().getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}
